import { Injectable } from "@angular/core";
import { AuthenticationService } from "../user/authentication.service";

@Injectable({
  providedIn: "root",
})
export class PermissionService {
  permissions: string[] = [];
  constructor(private authenticationService: AuthenticationService) {
    var user = authenticationService.getCurrentUser();
    if (user) this.permissions = user.permissions;
  }

  isGranted(permission: string): boolean {
    return this.permissions.some((x) => x == permission);
  }

  isAnyGranted(permissions: string[]): boolean {
    if (!permissions) {
      return false;
    }

    let isGrant = false;
    permissions.forEach((permission) => {
      if (this.isGranted(permission)) {
        isGrant = true;
        return;
      }
    });
    return isGrant;
  }
  getPermission() {
    return this.permissions;
  }

// modifyPermissions(fromPermission1: string, fromPermission2: string, toPermission: string) {
//   const permissionsToRemove = [fromPermission1, fromPermission2];

//   permissionsToRemove.forEach(permission => {
//     const index = this.permissions.indexOf(permission);
//     if (index !== -1) {
//       this.permissions.splice(index, 1);
//     }
//   });

//   this.permissions.push(toPermission);
//   return this.permissions;
// }
modifyPermissions(fromPermission1: string, fromPermission2: string, toPermission: string) {
  const permissionsToRemove = [fromPermission1, fromPermission2];
  this.permissions = this.permissions.filter(p => !permissionsToRemove.includes(p));

  if (!this.permissions.includes(toPermission)) {
    this.permissions.push(toPermission);
  }

  return this.permissions;
}

modifyPermissionsForDigiEye(
  permissionsToRemove: string[],
  permissionToAdd: string
): string[] {
  permissionsToRemove.forEach(permission => {
    const index = this.permissions.indexOf(permission);
    if (index !== -1) {
      this.permissions.splice(index, 1);
    }
  });

  if (!this.permissions.includes(permissionToAdd)) {
    this.permissions.push(permissionToAdd);
  }

  return this.permissions;
}


}
